module.exports = __webpack_public_path__ + "static/office-outside-wide-43c92bd91bcdd602e84d69d4ff4a3230.jpg";